/**
 * Resolve DOM targets for OS-mode overlays (dialogs, drawers).
 *
 * Standard pattern: portal into the scoped `[data-window-content]` region
 * (overflow-hidden, rounded-b-3xl) so backdrops stay clipped inside the
 * window. The shell (`[data-window-id]`) uses overflow-visible for resize
 * handles and must not host full-window overlays.
 */

function escapeWindowId(windowId: string): string {
  return typeof CSS !== "undefined" && "escape" in CSS
    ? CSS.escape(windowId)
    : windowId.replace(/"/g, '\\"');
}

/** Scrollable, clipped content region inside an OS window — portal target for overlays. */
export function getOsWindowOverlayPortalElement(
  windowId: string | undefined,
): HTMLElement | null {
  return getOsWindowContentElement(windowId);
}

/** Scrollable content region inside an OS window. */
export function getOsWindowContentElement(
  windowId: string | undefined,
): HTMLElement | null {
  if (!windowId || typeof document === "undefined") return null;
  return document.querySelector(
    `[data-window-id="${escapeWindowId(windowId)}"] [data-window-content="true"]`,
  ) as HTMLElement | null;
}
